import { render, staticRenderFns } from "./PackageDescriptorCreate.vue?vue&type=template&id=5914a70d&"
import script from "./PackageDescriptorCreate.vue?vue&type=script&lang=js&"
export * from "./PackageDescriptorCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports